<template>
    <div class="bgFrame">
        <div :class="boxClass" style="z-index:500;">
            <img src="../../assets/home_banner3.png" class="bgImg" />
        </div>
        <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
        </div>
        <div class="box" style="z-index:502;height: auto;overflow: visible;align-items: center;justify-content: flex-start;">
            <div class="textFrame">
                <div :class="topMessageClass">
                    <div style="margin-top:184px;"></div>
                    <div class="textTitle">個性化，更合你</div>
                    <img src="../../assets/home_text_eng3.png" class="textImg" />
                </div>
                <div style="width:100%;margin-top: 107px;"></div>
                <div :class="bottomMessageClass">
                    NuMatch通過瞭解你的身體基本數據，根據你的健康目標、飲食偏好、過敏源等情況，利用智能AI演算形成你的個人營養數據量化配餐方案，並通過對宏量營養素如碳水、脂肪、蛋白質等作科學定量管理。<br><br> 選購餐品時即時顯示每餐健康分數，讓你食對與否都可心裏有數，輕鬆享受私人定制的營養餐，達成餐餐健康飲食、營養均衡的好習慣。
                </div>
                <div style="width:100%;margin-top: 50px;"></div>
                <el-button :class="btnClass" color="#6B834B" size="large" round @click="pushLogin">生成我的營養方案</el-button>
            </div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default {
  name: 'App',
  components: {
  },
  setup() {

      const userRouter = useRouter();

    onMounted(() => {
    });
    let topMessageClass = ref('start_textSubFrame')
    let bottomMessageClass = ref('start_textContent')
    let btnClass = ref('start_orderBtn')
    let boxClass = ref('box_normal')

    const startAnime = ref(false)
    const changeAnime = () =>{
        topMessageClass.value = 'start_textSubFrame'
        bottomMessageClass.value = 'start_textContent'
        btnClass.value = 'start_orderBtn'
        boxClass.value = 'box_normal'

        if (startAnime.value == false) {
          setTimeout(() => {
            boxClass.value = 'box_anime'
            topMessageClass.value = 'textSubFrame'
            setTimeout(() => {
              bottomMessageClass.value = 'textContent'
            }, 400);
            setTimeout(() => {
              btnClass.value = 'orderBtn'
            }, 900);
          }, 800);
        }
    }
    const pushLogin = () => {
      userRouter.push({
        path: "/register",
        query: {},
      });
    };
    let pointImg = ref(require('../../assets/noise.png'))
    return {
      boxClass,
      pointImg,
      userRouter,
      pushLogin,
      changeAnime,
      startAnime,
      bottomMessageClass,
      topMessageClass,
      btnClass
    };
  },
}
</script>

<style scoped lang="less">
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}

.box_normal{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0;
}
.bgFrame{
    overflow: hidden;
    width: 100%;
    height: 100%;
    background: rgb(242, 241, 229);
}
.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}
.textFrame{
  height: 100%;
  margin-left: calc((100% - 1100px) / 2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
@keyframes textSubAnime {
  from {
      transform: translate(0px, -60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textSubFrame{
    display: flex;
    flex-direction: column;
    justify-content: left;
    animation-name: textSubAnime;
    animation-duration: 1s;
    opacity: 1;
}

.start_textSubFrame{
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.textTitle{
    font-size: 65px;
    font-family: MicrosoftYaHeiLight;
    color: #685647;
    text-align: left;
    line-height: 87px;
}
.textImg{
  width: 441px;
}

@keyframes textContentAnime {
  from {
      transform: translate(0px, 60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textContent{
  width: 613px;
    text-align: left;
    font-size: 18px;
    font-family: MicrosoftYaHeiLight;
    color: #333333;
    animation-name: textContentAnime;
    animation-duration: 1s;
    opacity: 1;
}

.start_textContent{
  width: 613px;
  opacity: 0;
  text-align: left;
  font-size: 16px;
  font-family: MicrosoftYaHeiLight;
  color: #685647;
  line-height: 29px;
}

@keyframes btnAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}

.orderBtn{
  width: 204px;
  height: 57px;
  opacity: 1;
  animation-name: btnAnime;
  border-radius: 28px !important;
  animation-duration: 0.5s;
}

.start_orderBtn{
  width: 204px;
  height: 57px;
  border-radius: 28px !important;
  opacity: 0;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1.3s steps(2) infinite;
}
:deep(.el-button>span) {
  color: white;
  font-size: 18px;
}

</style>
